var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisaCard = function SvgVisaCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.51 8.197-4.313 10.64h-2.815l-2.116-8.492c-.128-.522-.24-.714-.631-.934-.649-.36-1.706-.697-2.635-.898l.063-.316h4.53c.297 0 .583.109.808.308.226.199.374.475.42.777l1.122 6.15 2.77-7.235h2.798Zm11.029 7.166c.012-2.808-3.756-2.963-3.73-4.217.008-.381.358-.788 1.129-.89a4.89 4.89 0 0 1 2.625.472l.467-2.255A6.927 6.927 0 0 0 29.539 8c-2.632 0-4.484 1.446-4.499 3.517-.017 1.533 1.323 2.386 2.332 2.895 1.036.522 1.384.857 1.373 1.322 0 .714-.828 1.03-1.594 1.042-1.337.022-2.116-.373-2.735-.671l-.482 2.33c.622.295 1.771.552 2.961.565 2.798 0 4.627-1.42 4.636-3.64l.008.003Zm6.942 3.467h2.462L38.803 8.197h-2.273a1.184 1.184 0 0 0-.685.213c-.202.141-.358.342-.449.576l-3.992 9.852h2.792l.564-1.59h3.416l.306 1.582Zm-2.96-3.763 1.403-3.995.807 3.995h-2.21Zm-11.206-6.87-2.203 10.64h-2.661l2.202-10.64h2.662Z",
    fill: "url(#visa-card_svg__a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47.944,
    height: 26,
    rx: 3.5,
    stroke: "#E2E0DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa-card_svg__a",
    x1: 8,
    y1: 13.504,
    x2: 40.951,
    y2: 13.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164194"
  })))));
};
export default SvgVisaCard;